import React, { Fragment } from 'react'

const PublicLayout = ({ children }) => {
  return (
    <Fragment>{children}</Fragment>
  )
}

export default PublicLayout